import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import store from './store';

import Grid from '@mui/material/Grid';
import AppBar from './components/AppBar';
import ListRoute from './routes';
import { makeStyles } from '@mui/styles';
import { LanguageProvider } from './contexts/LanguageContext';
import './App.css';

import('dayjs/locale/id');

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: '1440px',
    width: '100%',
    margin: '100px auto 0px',
    backgroundColor: '#fffff0'
  }
}));


function App(props) {
  const classes = useStyles();

  return (
    <Provider store={store}>
      <LanguageProvider>
        <Grid>
          <BrowserRouter>
            {/* <AppBar /> */}
            <ListRoute />
          </BrowserRouter>
        </Grid>
      </LanguageProvider>
    </Provider>
  );
}

export default App;

